import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5n93k33wnd: FaireBrandEntity = {
  token: "b_5n93k33wnd",
  type: "brand",
  name: "Strut & Bolt",
  avatarUrl:
    "https://cdn.faire.com/fastly/8dccaf771905219e2660a19ce0246c2136c8f671d64b744910f942954d0093ec.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/89dd8968804406c2e21e9299727385455df3d79fb68cad590b59888bd8e4c12e.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/8dccaf771905219e2660a19ce0246c2136c8f671d64b744910f942954d0093ec.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/89dd8968804406c2e21e9299727385455df3d79fb68cad590b59888bd8e4c12e.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.8,
  reviewCount: 166,
  isTopShop: true,
  isInsider: true,
  description:
    "Established in 2016, Strut and Bolt was developed to keep up with new women's lifestyle that requires both sophistication and comfort demanded in today's world. With our exclusive fabrics and prints developed in Europe and Brazil, we hope to make our concept of metropolitan glamour available to all women. We strive to continually manufacture and design the latest in runway and street trends, exemplifying up-to-the-minute affordable styles that are never dull and never plain.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:21:40.587Z",
    importedBy: "entity-db-cli",
  },
};
